import React, { useState, useMemo } from "react";

import { Table, TableContainer } from "../Table";

import { DataTableBody, DataTableCell, DataTableContent, DataTableRow } from "@rmwc/data-table";
import "@rmwc/data-table/styles";

import Palette from "../../palette.json";
import { DialogActions, DialogButton, DialogContent, DialogTitle as DialogTitleBase } from "@rmwc/dialog";
import "@rmwc/data-table/styles";
import "@rmwc/list/styles";

import { TextInput } from "components/TextInput";
import { Dialog } from "../Dialog";
import { ListItemPrimaryText, ListItemText } from "@rmwc/list";
import { Button } from "components/Button";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useAdminApi } from "hooks/useAdminApi";
import { useClient } from "hooks/params/useClient";
import { LocationFields } from "types/admin/LocationFields";

const DialogTitle = styled(DialogTitleBase)`
  display: flex;
  align-items: center;

  border: none;

  > span {
    margin: 20px 3rem 0 0;
    flex-grow: 1;
  }

  > button {
    margin: 20px 0 0;
  }
`;

const FilterControls = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > * {
    margin-right: 1rem;
    :last-child {
      margin-right: 0;
    }
  }
`;

interface ClientAssignLocationDialogPropsT {
  locations: LocationFields[];
}

export const ClientAssignLocationDialog: React.FC<ClientAssignLocationDialogPropsT> = ({ locations }) => {
  const history = useHistory();
  const client = useClient();
  const { assignLocationToClient, unassignLocationFromClient } = useAdminApi();
  const [searchString, setSearchString] = useState<string>("");

  const filtered = useMemo(
    () => locations.filter((it) => it.name.toLowerCase().includes(searchString.toLowerCase())),
    [searchString],
  );

  const onButtonClick = async (location: LocationFields, assigned: boolean) => {
    if (assigned) {
      await unassignLocationFromClient({ clientId: client.id, locationId: location.id });
      return;
    }

    await assignLocationToClient({ clientId: client.id, locationId: location.id });
  };

  return (
    <Dialog renderToPortal open>
      <DialogTitle>
        <span>Manage Client Locations</span>
      </DialogTitle>

      <DialogContent style={{ minWidth: "500px" }}>
        <FilterControls>
          <TextInput
            placeholder="Search by name."
            value={searchString}
            onChange={(ev) => setSearchString(ev.target.value)}
          />
        </FilterControls>

        <TableContainer>
          <Table>
            <DataTableContent>
              <DataTableBody>
                {!locations?.length ? (
                  <DataTableRow>
                    <DataTableCell
                      colSpan={3}
                      style={{ color: Palette.LightGrey, fontSize: "18px", textAlign: "center" }}
                    >
                      - No Locations -
                    </DataTableCell>
                  </DataTableRow>
                ) : (
                  <>
                    {filtered.map((location) => {
                      const assigned = !!client.locations?.items.find((it) => it.locationId === location.id);

                      return (
                        <DataTableRow key={location.id}>
                          <DataTableCell>
                            <ListItemText>
                              <ListItemPrimaryText style={{ marginTop: "-20px" }}>{location.name}</ListItemPrimaryText>
                            </ListItemText>
                          </DataTableCell>
                          <DataTableCell alignEnd>
                            <Button
                              style={{ width: "7rem" }}
                              outlined={!assigned}
                              raised={assigned}
                              onClick={(ev) => {
                                ev.stopPropagation();
                                onButtonClick(location, assigned).then();
                              }}
                            >
                              {assigned ? "Assigned" : "Assign"}
                            </Button>
                          </DataTableCell>
                        </DataTableRow>
                      );
                    })}
                  </>
                )}

                <div style={{ height: "200px" }}></div>
              </DataTableBody>
            </DataTableContent>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <DialogButton onClick={history.goBack}>Close</DialogButton>
        <DialogButton raised isDefaultAction action="accept" onClick={history.goBack}>
          Done
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
};
